import React, { Fragment, PureComponent } from 'react';
import { RouteComponentProps } from 'react-router';
import { Container } from 'semantic-ui-react';
import { GENRE_RUNS_QUERY } from '../../apollo';
import { RunTableCol, SortDir } from '../../types';
import { GenreSegment } from '../HeaderSegments';
import RunTable from '../RunTable';
import Ad from '../Shared/Ad';

const cols: RunTableCol[] = [
  RunTableCol.Vods,
  RunTableCol.GameNoYear,
  RunTableCol.Year,
  RunTableCol.Platform,
  RunTableCol.Category,
  RunTableCol.Event,
  RunTableCol.Runners,
  RunTableCol.Time,
];

interface MatchParams {
  id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

class GenrePage extends PureComponent<Props> {
  public render() {
    const { match } = this.props;
    return (
      <Fragment>
        <GenreSegment genreId={match.params.id} />
        <Container>
          <Ad key="GenrePage" />
          <RunTable
            key={`genre-${match.params.id}`}
            query={GENRE_RUNS_QUERY}
            queryVars={{ genre: match.params.id }}
            defaultSortCol={RunTableCol.GameNoYear}
            defaultSortDir={SortDir.Ascending}
            cols={cols}
          />
        </Container>
      </Fragment>
    );
  }
}

export default GenrePage;
export { GenrePage };
